import axios from 'axios'
import qs from 'qs'

// 环境的切换
// if (process.env.NODE_ENV == 'development') {
//   axios.defaults.baseURL = 'https://www.baidu.com'
// } else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = 'https://www.ceshi.com'
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'https://www.production.com'
// }

// 请求超时时间
axios.defaults.timeout = 30000

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'

// 请求拦截器
axios.interceptors.request.use(
  config => {
    if (config.headers['Content-Type'] === 'multipart/form-data') return config;
    if (config.method === 'post' && config.data) {
      config.data = qs.stringify(config.data);
    }
    if (config.method === 'get') {
      if (!config.params) config.params = {};
    }
    return config
  },
  error => {
    return Promise.error(error)
  }
)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    return Promise.reject(error.response)
  }
)

export function get(url, params) {
  return new axios(url, { params: params })
}
export function post(url, params) {
  return axios.post(url, params)
}
export const up = (params) => {
  let formdata = new FormData()
  formdata.append('mode', 'upload')
  formdata.append('file', params.file)
  return axios.post('/NewAPI/File/FileAPI?mode=upload', formdata, {
    headers: { "Content-Type": "multipart/form-data" }
  })
}
